<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
    <filter id="shadow">
        <feDropShadow dx="0" dy="0" stdDeviation="1"
                      flood-color="rgba(0, 0, 0, 0.25)"/>

    </filter>
    <path d="M0 0h24v24H0V0z" style="fill:none; filter:url(#shadow);"/>
    <path d="M8 5v14l11-7L8 5z" style="fill:white; filter:url(#shadow);"/>
</svg>
